import React, { useState, useEffect } from "react";
import { Grid,
  Select,
  OutlinedInput,
  MenuItem,  } from "@material-ui/core";
import MUIDataTable from "mui-datatables";

// styles
import useStyles from "./styles";

// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import { Typography } from "../../components/Wrappers";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import firebase from "../../firebase.js"
import { ja } from "date-fns/esm/locale";


var database = firebase.database();
function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

export default function EmployeeData() {
  var classes = useStyles();
  var dateArray =[];
  var datatableData = [];
  var dataHeader =[];
  var quarter = "Q1";
  var shift = "ALL";
  const [startDateState, setStartDate] = React.useState(new Date());
  const [endDateState, setEndDate] = React.useState(new Date());
  var [dataState, setDataState] = useState(datatableData);
  var [headerState, setHeaderState] = useState(dataHeader);
  var [quarterState, setQuarterState] = useState(quarter);
  var [shiftState, setShiftState] = useState(shift);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    dateArray=[];
    for(var date=new Date(startDateState); date<=endDateState;date.setDate(date.getDate()+1))
    dateArray.push(formatDate(date));
    console.log(dateArray);
    var shiftArray=["DS", "NS", "FS"];
    var quarterArray = ["Q1", "Q2", "Q3", "Q4"];

    var typeArray = ["status", "timestamp"];
    var ref = database.ref('ENS5/Employee Data');
    ref.on('value', function(snapshot) {
      datatableData=[];
      dataHeader=["Employee Code", "Employee Name","Category", "Shift", "Station" ];
      var j=0;
      dateArray.forEach(date=>{
        shiftArray.forEach(shift=>{
          quarterArray.forEach(quarter=>{
            typeArray.forEach(category=>{
              dataHeader.push(date+"\n"+shift+"\n"+quarter+"\n"+category);
              //datatableData[i]=datatableData[i]||[];
            });  
        });
      });
    });
      snapshot.forEach(function(employeeSnapshot) {
        console.log("loop1");
        datatableData[j]=datatableData[j]||[];
        datatableData[j][0]=employeeSnapshot.key;
        datatableData[j][1]=employeeSnapshot.child("Name").val();
        datatableData[j][2]=employeeSnapshot.child("category").val();
        datatableData[j][3]=employeeSnapshot.child("shift").val();
        datatableData[j][4]=employeeSnapshot.child("Station").val();
        var i=5;
        dateArray.forEach(date=>{
          shiftArray.forEach(shift=>{
            quarterArray.forEach(quarter=>{
              typeArray.forEach(category=>{
                //dataHeader.push(date+" "+shift+" "+quarter+" "+category);
                //datatableData[i]=datatableData[i]||[];
            
                datatableData[j][i]=employeeSnapshot.child("Attendance").child(date).child(shift).child(quarter).child(category).val();
                i++;
              });  
          });
        });
    });
    j++;
    });
    setDataState(dataState=>datatableData);
    setHeaderState(headerState=>dataHeader);
    console.log(dataState);
    });

    return() => {
      ref.off();
      }
  
    }, [startDateState, endDateState])

  return (
    <>
      <PageTitle title="Employee Data" />
      <Grid align="center" alignItems="center" container spacing={4}>
        <Grid item lg={3} md={6} sm={6} xs={16}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="Start Date"
          format="yyyy-MM-dd"
          value={startDateState}
          onChange={handleStartDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </MuiPickersUtilsProvider>
        </Grid>
      <Grid item lg={3} md={6} sm={6} xs={16}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="End Date"
          format="yyyy-MM-dd"
          value={endDateState}
          onChange={handleEndDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </MuiPickersUtilsProvider>
        </Grid>
        <Grid item lg={3} md={6} sm={6} xs={4}>
        <Select
                  value={shiftState}
                  onChange={e => setShiftState(e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      classes={{
                        notchedOutline: classes.mainChartSelectRoot,
                        input: classes.mainChartSelect,
                      }}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="ALL">ALL SHIFTS</MenuItem>
                  <MenuItem value="DS">DS</MenuItem>
                  <MenuItem value="NS">FS</MenuItem>
                  <MenuItem value="FS">NS</MenuItem>
                </Select>
                </Grid>
        </Grid>
        <Grid item lg={3} md={6} sm={6} xs={4}>
        <Select
                  value={quarterState}
                  onChange={e => setQuarterState(e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      classes={{
                        notchedOutline: classes.mainChartSelectRoot,
                        input: classes.mainChartSelect,
                      }}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="Q1">First Quarter</MenuItem>
                  <MenuItem value="Q2">Second Quarter</MenuItem>
                  <MenuItem value="Q3">Third Quarter</MenuItem>
                  <MenuItem value="Q4">Fourth Quarter</MenuItem>
                  <MenuItem value="ALL">ALL</MenuItem>
                </Select>
                </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Employee List"
            data={dataState}
            columns={headerState}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
